import { Component, Vue, Watch, Prop} from 'vue-property-decorator'

@Component({})
export default class MenuData extends Vue {
    // ------ prop ------
    @Prop() datas: any
    // ------ 生命周期 ------
    created(){
        console.log(this.datas);
    }


    @Watch('datas', { immediate: true })
    handleWatchDatas() {
        console.log('11',this.datas)
    }

}